import React from "react";
import { css, withTheme, keyframes } from "styled-components";
import { Flex, Box, Card } from "rebass";
import PropTypes from "prop-types";
import theme from "../../../theme";
import LogoSvg from "./logo";
import MenuIcon from "../../images/menu.svg";
import CloseIcon from "../../images/close.svg";

const pop = keyframes`
  from {
    transform: translate(60px, 60px);
  }
  to {
    transform: translate(0, 0);
  }
`;

export const Wrapper = ({ children }) => (
  <Box
    css={css`
      position: fixed;
      pointer-events: none;
      z-index: 10;
      bottom: 0;
      left: 0;
      right: 0;
      line-height: 1;
      @media (min-width: 1024px) {
        left: ${theme.posterW.large};
      }
    `}
  >
    {children}
  </Box>
);

Wrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export const FoldOut = ({ children }) => (
  <Flex
    flexDirection="column"
    justifyContent="flex-end"
    pt="5"
    px="4"
    pb="6"
    css={css`
      background: white;
      position: fixed;
      bottom: 0px;
      right: 0px;
      left: 0px;
      overflow: hidden;
      overflow-y: auto;
      z-index: 9;
      border: 20px solid black;
      animation: ${pop} 0.2s linear 1;
      @media (min-width: 360px) {
        left: auto;
      }
    `}
  >
    <Box>{children}</Box>
  </Flex>
);

FoldOut.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};
export const Logo = withTheme(({ theme, invert, ...rest }) => (
  <Box
    fontSize={[4, 5]}
    css={css`
      width: 4em;
      margin: 0 0 1em 1em;
    `}
  >
    <LogoSvg color={invert ? "#FFFFFF" : theme.colors.primary} {...rest} />
  </Box>
));

Logo.propTypes = {
  src: PropTypes.string.isRequired
};

export const MenuToggle = ({ isOpen, onClick }) => (
  <Card
    onClick={onClick}
    fontSize={[4, 5]}
    bg="primary"
    backgroundImage={`url(${isOpen ? CloseIcon : MenuIcon})`}
    backgroundSize="80%"
    backgroundPosition="center center"
    backgroundRepeat="no-repeat"
    css={css`
      pointer-events: auto;
      content: "";
      width: 2em;
      height: 2em;
      border-radius: 2em;
      position: fixed;
      bottom: 1em;
      right: 1em;
      cursor: pointer;
      fill: red;
    `}
  />
);

MenuToggle.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
